import type { WithActiveBranchId } from '@app/api/shared';

export enum SalePlansEndpoints {
  UpdateSalePlans = 'UpdateSalePlans',
  GetSalesPlan = 'GetSalesPlan',
  ExportSalePlansToExcelByYear = 'ExportSalePlansToExcelByYear',
}

export interface ModelSalePlan {
  Id: number;
  BranchId: number;
  Branch: string | null;
  ClientServiceCategoryId: number;
  ClientServiceCategory: string | null;
  ClientServiceCategoryIsDelete: boolean | null;
  PlanMoney: string | null;
  MonthYear: string;
}

export interface ModelGetSalePlanTotalService {
  Total: string | null;
  TotalPlanMoneyByMonths: Record<string, string> | null;
}

export interface ModelGetSalePlan {
  SalePlans: ModelSalePlan[] | null;
  Years: number[] | null;
  TotalPlanMoneyByMonths: Record<string, string> | null;
  TotalPlanMoneyByServices: Record<string, ModelGetSalePlanTotalService> | null;
  StartYear: number | null;
}

export interface ModelFile {
  Id: number;
  Name: string | null;
  Data: string | null;
  Lifetime: string | null;
  Description: string | null;
}

export type UpdateSalePlansRequest = WithActiveBranchId<{
  data: ModelSalePlan[];
}>;
export type GetSalesPlanRequest = WithActiveBranchId<{
  year?: number;
}>;
export type ExportSalePlansToExcelByYearRequest = WithActiveBranchId<{
  year: number;
}>;

export type UpdateSalePlansResponse = ModelSalePlan[];
export type GetSalesPlanResponse = ModelGetSalePlan;
export type ExportSalePlansToExcelByYearResponse = ModelFile;
